import * as React from "react";
import { SVGProps, memo } from "react";

const SvgArrowRightPrimary = (props: SVGProps<SVGSVGElement>) => (
  <svg width={12} height={13} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#ArrowRightPrimary_svg__a)">
      <path d="m4.425 2.53 7.087 4.056-7.087 4.055" stroke="#008E44" strokeMiterlimit={10} />
    </g>

    <defs>
      <clipPath id="ArrowRightPrimary_svg__a">
        <path fill="#fff" transform="rotate(45 1.879 7.707)" d="M0 0h8v8H0z" />
      </clipPath>
    </defs>
  </svg>
);

const Memo = memo(SvgArrowRightPrimary);

export default Memo;
